export default [
    {
        path: '/floors',
        name: 'floors',
        component: () => import ('./pages/Index')
    },
]